const modal = {
  'pages.material.components.category-selector-modal.title': '选择品类',
  'pages.material.components.category-selector-modal.tip': '请选择品类',
}

export default modal
